// React
import { Navigate } from "react-router-dom";

// Libraries
import { useTranslation } from "react-i18next";

// Components
import PortalLoading from "Common/Components/PortalLoading";

// Auth
import { useMBSAuth } from "Auth/MBS/MBSAuthContext";

const MBSAuthRedirect = () => {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useMBSAuth();

  if (isLoading) {
    return <PortalLoading message={t("common.loading")} />;
  }

  return <Navigate to={isAuthenticated ? "/mbs/home" : "/mbs/login"} replace />;
};

export default MBSAuthRedirect;
